export default __webpack_public_path__ + "static/media/biodegradable-biodegradable-icon.1e81bba1.svg";